
<template>
  <div>
    <v-menu v-model="menu" width="700px" offset-y  :close-on-click="true"  :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <v-chip v-bind="attrs" v-on="on" :color="solution_map.color">
          <template v-if="activeModalityId">
            <v-icon small left>mdi-star</v-icon>
            {{ modality_name }}
          </template>
          <template v-if="!activeModalityId">
            <v-progress-circular :size="20" color="white" indeterminate></v-progress-circular>
          </template>
        </v-chip>
      </template>

      <v-card :width="had_wholesale && had_retail ? '700px' : '300px'">
        <v-card-title class="d-flex justify-center">
          Selecione o módulo
        </v-card-title>
        <v-card-text>
          <v-row >
            <v-col 
              cols="12" class="pa-1" 
              v-if="
                !['IndexPayShippings', 'PrintShipping', 'ShowDriverPayShipping'].includes($route.name) &&
                (had_wholesale && had_retail)
              "
            >
              <v-btn tile elevation="0" block @click="selectModule(-1)">Listar todos os módulos</v-btn>
            </v-col>
            <v-col cols="12" :sm="had_wholesale && had_retail  ? 6 : 12" class="pa-1" v-if="modalities_filtered_retail.length > 0">
                <v-list>
                  <template v-for="(module, idx) in modalities_filtered_retail" >
                    <v-divider></v-divider>
                    <v-list-item @click="selectModule(module)" :class="[[idx % 2 == 0 ? '' : 'grey lighten-5']]">
                      <v-list-item-icon>
                        <v-icon> mdi-store</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <div>
                          <span>{{module.name}}</span>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-list>
            </v-col>

            <v-divider vertical class="my-3"></v-divider>

            <v-col cols="12" :sm="had_wholesale && had_retail ? 6 : 12" class="pa-1" v-if="modalities_filtered_wholesale.length > 0">
                <v-list>
                  <template v-for="(module, idx) in modalities_filtered_wholesale" >
                    <v-divider></v-divider>
                    <v-list-item @click="selectModule(module)" :class="[[idx % 2 == 0 ? '' : 'grey lighten-5']]">
                      <v-list-item-icon>
                        <v-icon> mdi-truck</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <div>
                          <span>{{module.name}}</span>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-list>
            </v-col>
          </v-row>

        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import change_module from "@/mixins/change_module.js"

export default {
  name: 'ModuleChip',
  mixins: [change_module],
  components:{
  },
  data() {
    return {
      menu: false,
    }
  },
  methods: {
    selectModule(module){
      if(module == -1){
        this.selected_modality = parseInt(-1)
      }else{
        this.selected_modality = parseInt(module.id)
      }
      this.menu = false
    },
  },
  computed: {
    solution_map(){
      return {text:"Galpão", color:"error"}
    },
    modalities_filtered_wholesale() {
      const modalities = JSON.parse(JSON.stringify([...this.filter_modalities])) 
      // if(['IndexPayShippings', 'PrintShipping', 'ShowDriverPayShipping'].includes(this.$route.name)){
        return modalities.filter(el=> el.solution == 'wholesale')
      // }
    },
    modalities_filtered_retail() {
      const modalities = JSON.parse(JSON.stringify([...this.filter_modalities])) 
      // if(['IndexPayShippings', 'PrintShipping', 'ShowDriverPayShipping'].includes(this.$route.name)){
      return modalities.filter(el=> el.solution == 'retail')
      // }
    },
    all_options(){
      const modalities = JSON.parse(JSON.stringify([...this.filter_modalities])) 
      if(['IndexPayShippings', 'PrintShipping', 'ShowDriverPayShipping'].includes(this.$route.name)){
        return modalities.filter(el => el.id == -1)
      }
    },
    had_wholesale(){
      return this.modalities_filtered_wholesale.length > 0
    },
    had_retail(){
      return this.modalities_filtered_retail.length > 0
    },
    ...mapState({
      activeModalityId: state => state.App.activeModalityId,
      modality_name: state => state.App.activeModalityName,
    })
  },
  mounted() {
    this.getData()
  },
}
</script>